import React , {Component} from 'react';
import Avatar from '../../../assets/images/avatar.png';
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/tour/';



export default class TourListPage extends Component{
    // constructor(){
    //     super()
    // }

    HandleImage = (image)=>{
       
        //alert(image)
        let tourImage = image.slice(0 ,image.indexOf(','))
      //  alert(tourImage) \

          let finalImage = img_path+tourImage

      return finalImage
        
    }

    AddSpecialChar = (str) => {
        if (str !== '' && str !== undefined && str !== null)
            return str.replace(/pnk_Amp/g, "&");
    }

    render(){
        return(
            <div>
            
           {/* <div class="form-back-link" onClick={() => this.props.HandleRouting('home')}>
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    <a>Back</a>
                </div>
        */}
                <div class="all-organizers-list-main">
                    <div class="container-fluid">
                    <div className="row">
                    <div className="col-6 col-md-3 col-lg-3">
                        <h3>Tours</h3>
                        </div>
                        <div className="col-6 col-md-3 col-lg-3">
                        <div className="organizer-list-add-btn">
                        <button type="button" className="btn" onClick={() => this.props.AddTour()}>Add Tour</button>
                        </div>
                        </div>
                        </div>

                        <div class="organizers-list-div">
                            <div class="row">
                                <div class="col-md-10 col-lg-10 organizers-head-list-desktop">
                                    <div class="row">
                                        <div class="col-md-1 col-lg-1">
                                            <div class="users-list-head">
                                                <h5>Sr.No.</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Tour Name</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Tour Cost</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-lg-3">
                                            <div class="users-list-head">
                                                <h5>Duration</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Status</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Tour Theme</h5>
                                            </div>
                                        </div>



                                    </div>

                                </div>
                                <div class="col-md-12 col-lg-12 organizers-list-desktop">
                                { this.props.tourlist.length>0?

                                    this.props.tourlist.map((item,i)=>(

                                    <div class="users-list-details" >
                                        <div class="row">
                                        <div class="col-md-10 col-lg-10" onClick={() => this.props.GetTourDetails(item.tour_seo_url)}>
                                        <div class="row">
                                            <div class="col-md-1 col-lg-1">
                                                <div class="users-list-content">
                                                    <p>{i+1}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <div class="users-list-content">
                                                    <p>{this.AddSpecialChar(item.tour_name)}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <div class="users-list-content">
                                                    <p>Rs. {this.AddSpecialChar(item.tour_pricing)}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-lg-3">
                                                <div class="users-list-content">
                                                    <p>{this.AddSpecialChar(item.tour_duration)}</p>
                                                </div>
                                            </div>
                                            {item.tour_status === '1' || item.tour_status === 1?
                                            <div class="col-md-2 col-lg-2">
                                            <div class="users-list-content">
                                                <p>Active</p>
                                            </div>
                                        </div>
                                        : <div class="col-md-2 col-lg-2">
                                        <div class="users-list-content">
                                            <p>InActive</p>
                                        </div>
                                    </div>
                                }
                                           
                                            <div class="col-md-2 col-lg-2">
                                                <div class="users-list-content">
                                                    <p>{this.AddSpecialChar(item.tour_theme)}</p>
                                                </div>
                                            </div>

                                            </div>
                                            </div>

                                            <div class="col-md-2 col-lg-2">
                                                <div class="users-list-content">
                                                <i style={{fontSize:'20px'}} class="fa fa-trash" aria-hidden="true"
                                                onClick={()=>this.props.DeleteModal(item._id)}
                                                ></i>
                                                </div>
                                            </div>

                                        </div>



                                    </div>
                                    ))
        :''}
                                    
                                </div>

                                <div class="col-md-12 col-lg-12 organizers-list-mobile">
                                { this.props.tourlist.length>0?

                                    this.props.tourlist.map((item,i)=>(

                                    <div class="users-list-details" onClick={() => this.props.GetOrganizerDetails(item._id)}>
                                        <div class="row">
                                        <div class="col-4">
                                        <div class="users-list-content-img">
                                               { item.tour_image === '' || item.tour_image === undefined  ?
                                               <img src={Avatar} alt='loading...'/>
                                               :
                                            <img src={this.HandleImage(item.tour_image)} alt='loading...'/>
                                               }
                                        </div>
                                    </div>
                                           {/* <div class="col-md-1 col-lg-1">
                                                <div class="users-list-content">
                                                    <p>{i+1}</p>
                                                </div>
                                    </div> */}
                                            <div class="col-6">
                                           
                                            
                                            <div class="users-list-content">
                                                    <p>{this.AddSpecialChar(item.tour_name)}</p>
                                                </div>
                                            
                                                <div class="users-list-content">
                                                <p>{this.AddSpecialChar(item.tour_theme)}</p>
                                            </div>
                                               

                                            <div class="users-list-content">
                                            <p>Rs. {this.AddSpecialChar(item.tour_pricing)}</p>
                                        </div>

                                        {item.organizer_status === '1' || item.organizer_status === 1?
                                       
                                        <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="defaultCheckedDisabled2" checked disabled/>
                                                        <label style={{color:'black'}} class="custom-control-label" for="defaultCheckedDisabled2">Active</label>
                                                      </div>
                                   
                                    :
                                    <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="defaultUncheckedDisabled2" disabled/>
                                    <label class="custom-control-label" for="defaultUncheckedDisabled2">Active</label>
                                  </div>
                               
                            }
                                                
                                            </div>
                                            <div className='col-2'>
                                            <div class="delete-btn" >
                                        <i style={{fontSize:'20px'}} class="fa fa-trash" aria-hidden="true"
                                        onClick={()=>this.props.DeleteModal(item._id)}
                                        ></i>
                                        </div>
                                            
                                            </div>
                                        </div>



                                    </div>
                                    ))
        :''}
                                    
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

            </div>

        )
    }
}

